module.exports = __webpack_public_path__ + "img/pro_11.f62f81be.png";